// Composables
import { createRouter, createWebHistory, START_LOCATION, RouteRecordRaw } from "vue-router";
import { rotasAbertas, rotasRestritas } from "./agregadorRotas";
import useCounterStore from "@/store/user";
import {
  criarBreadcrumbs,
  verificarAcesso,
  ROTAS_IGNORADAS,
  converterHashFederado,
  filtrarRotasSeNecessario,
  redirecionarUltimaRota,
} from "./helpers";

export { rotasAbertas, rotasRestritas };

const routes: RouteRecordRaw[] = [...rotasAbertas, ...rotasRestritas];
const router = createRouter({
  linkActiveClass: "active",
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.afterEach((to, from) => {
  if (!ROTAS_IGNORADAS.includes(from.name as string)) {
    if (!ROTAS_IGNORADAS.includes(to.path)) {
      const userStore = useCounterStore();
      userStore.novaRota(to.fullPath);
    }
  }
});

router.beforeEach(async (to, from, next) => {
  // TODO: VERIFICAR ARRAY OBRAS SE VAZIO BUSCAR
  if (to.meta && to.meta.emManutencao) {
    next("/manutencao");
    return;
  }

  // Devolve `true` quando já chamou `next()` (T65, ESC-05) — antes o guard
  // seguia adiante sem checar, e `verificarAcesso`/o `else` abaixo podiam
  // chamar `next()` de novo na MESMA passagem.
  if (converterHashFederado(to, next)) return;

  // Rotas abertas com segmento dinâmico (ex.: /automacao/pedido/:token) não batem no
  // comparador de string exata de verificarAcesso (pathsAbertos.includes(to.path)), pois
  // to.path é a URL resolvida com o valor real do parâmetro. Usamos uma flag de meta
  // dedicada (meta.rotaPublica) marcada explicitamente na rota pública, em vez de comparar
  // to.matched[].path contra pathsAbertos — essa comparação de path colidia com o wrapper
  // LayoutGeral (path: "" em rotasRestritas), que coincide com o path "" de Home
  // (rotasAbertas), abrindo bypass para qualquer rota restrita aninhada nele.
  // Ver .duvidas/fase-5-guard-rota-publica-fix.md.
  const ehRotaAbertaComParametro = to.matched.some(
    (registro) => registro.meta?.rotaPublica === true,
  );

  if (ehRotaAbertaComParametro || verificarAcesso(pathsAbertos, to, next)) {
    filtrarRotasSeNecessario(from, START_LOCATION);

    criarBreadcrumbs(to);

    if (!redirecionarUltimaRota(from, to, next)) return next();
  } else {
    next("/403");
  }
});

const pathsAbertos = [...rotasAbertas].map((rota) => {
  return rota.path;
});

export default router;
